module.exports = __webpack_public_path__ + "static/media/tenant-screening-fr.6ede2f25.png";